export const register = {
  headline: "Register",
  inputLabels: {
    userName: "Username",
    password: "Password",
    email: "Email",
    repeatPassword: "Repeat Password",
  },
  mainActions: {
    register: "Register",
  },
  messages: {
    confirmationEmailSent:
      "An e-mail was sent to you. Please follow the instructions there in order to complete your registration.",
    registrationCodeInvalid:
      "Registration failed. This account does not exist or can not be activated right now.<br>Please try again later.",
    registrationSuccessful:
      '<h1 class="title is-2 has-text-grey">Thank you for signing up. </h1><p class="title is-3 has-text-grey">You are now able to login with your new account.</p>',
    userNameInvalid: "Your username can not contain <strong>@</strong> ",
    userNameTooShort: "Your username must be at least 4 characters",
    userNameAlreadyExists:
      'The username <span class="has-text-primary">{username}</span> is already taken. Please choose a different one.',
    passwordMinLength: "At least 8 characters.",
    passwordMaxLength: "At most 8 characters."
  },
};
